export default __webpack_public_path__ + "static/media/llavero.5d1faa11.jpg";